import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './locales/i18n'
import { ElDropdown, ElDropdownMenu, ElDropdownItem, ElDialog, ElInput, ElBacktop, ElAnchor, ElAnchorLink, ElMessage, ElLoading, ElRadioGroup, ElRadio, ElDrawer  } from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/fonts/fonts.css'
import VueLazyload from 'vue-lazyload'
const loadimage = require('./assets/img-loading.webp')
const errorimage = require('./assets/load-img-failed.png')
const app = createApp(App);
app.use(i18n)
app.use(router)
app.use(store)
app.use(VueLazyload, {
  // 可选的配置选项
  preLoad: 1.3,
  error: errorimage,
  loading: loadimage,
  attempt: 1
})

app.component(ElInput.name, ElInput)
app.component(ElDialog.name, ElDialog)
app.component(ElBacktop.name, ElBacktop)
app.component(ElDropdown.name, ElDropdown)
app.component(ElRadio.name, ElRadio)
app.component(ElDrawer.name, ElDrawer)
app.component(ElRadioGroup.name, ElRadioGroup)
app.component(ElDropdownMenu.name, ElDropdownMenu)
app.component(ElDropdownItem.name, ElDropdownItem)
app.component(ElAnchor.name, ElAnchor)
app.component(ElAnchorLink.name, ElAnchorLink)
app.provide('$message', ElMessage)
app.provide('$loading', ElLoading)
app.mount('#app')